import { useCallback, useEffect, useRef, useState } from 'react';

export const CLEAR_HOLD_ATTRIBUTE = 'data-clear-hold';

export const findHold = (events, holdPositionId, roomId) => (
  events.find((event) => event.hold_position_id === holdPositionId && event.room_id === roomId)
);

export const canClearHold = (user, hold) => (
  Boolean(hold && user.can_clear_holds && hold.clearable)
);

export const holdRoomNames = (events, rooms, hold) => {
  const roomIds = events
    .filter((event) => event.hold_position_id === hold.hold_position_id)
    .map((event) => event.room_id);

  return rooms
    .filter((room) => roomIds.includes(room.id))
    .map((room) => room.name);
};

export const useClearHold = (events, user) => {
  const [holdToClear, setHoldToClear] = useState(null);
  const eventsRef = useRef(events);
  const userRef = useRef(user);

  useEffect(() => {
    eventsRef.current = events;
  }, [events]);

  useEffect(() => {
    userRef.current = user;
  }, [user]);

  const holdBeingCleared = holdToClear
    ? findHold(events, holdToClear.holdPositionId, holdToClear.roomId)
    : undefined;

  useEffect(() => {
    if (holdToClear && !holdBeingCleared) setHoldToClear(null);
  }, [holdToClear, holdBeingCleared]);

  const handleClearHoldClick = useCallback((eventInfo) => {
    if (!eventInfo.jsEvent.target.closest(`[${CLEAR_HOLD_ATTRIBUTE}]`)) return false;

    eventInfo.jsEvent.preventDefault();
    const { hold_position_id: holdPositionId, room_id: roomId } = eventInfo.event.extendedProps;
    const hold = findHold(eventsRef.current, holdPositionId, roomId);
    if (canClearHold(userRef.current, hold)) setHoldToClear({ holdPositionId, roomId });
    return true;
  }, []);

  const closeClearHold = useCallback(() => setHoldToClear(null), []);

  return {
    holdBeingCleared,
    clearHoldOpen: Boolean(holdBeingCleared),
    handleClearHoldClick,
    closeClearHold,
  };
};
